<template>
	<div class="header">
		<div class="logo">
			<router-link to="/" name="home" class="logo-link"><img src="@/assets/images/logo.png" /></router-link>
		</div>
		<div class="router_menu" v-show="meun.show">
			<div
				class="router_menu_item"
				v-for="v in meun.list"
				:key="v.name"
				:class="{
					'is-active': v.path==route.path,
				}"
			>
				<router-link to="" class="item-title" @click="toHandle(v)" :name="v.path" >{{ v.title }}</router-link>
				<div class="sub-meun" v-if="v.children">
					<Product v-if="v.name === 'Products'" v-model:show="meun.show" />
					<Solution v-if="v.name === 'Solution'" v-model:show="meun.show" />
				</div>
			</div>
		</div>
		
		<el-button class="case_btn" @click="obtainSolutionsClick()">获取解决方案</el-button>
		<div class="router_menu-btn" @click="changeMeunShow">
			<svg-icon v-show="!meun.show" name="icon-meun" :width="28" :height="28" color="#0055D9"/>
			<svg-icon v-show="meun.show" name="icon-close" :width="22" :height="22" color="#0055D9"/>
		</div>
	</div>
</template>

<script lang="ts" setup name="PageHeader">
import { reactive, ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Product from './components/product.vue';
import Solution from './components/solution.vue';
import { getHeaderTop } from '@/api/home';
import { checkDevice } from '@/utils/index';
import EventBus from '@/utils/eventBus';
const router = useRouter();
const route = useRoute();
const meun =reactive({
	current: {title: '首页', showMask: true,path: '/home',name: 'home'},
	show: false,
	list: [{
			title: '首页',
			path: '/home',
			name: 'home'
		},
		{
			title: '产品介绍',
			path: '/products',
			name: 'Products',
			children: [],
		},
		{
			title: '解决方案',
			path: '/solution',
			name: 'Solution',
			children: []
		},
		{
			title: '成功案例',
			path: '/cases',
			name: 'cases'
		},
		{
			title: '下载中心',
			path: '/download',
			name: 'download'
		},
		{
			title: '关于我们',
			path: '/about',
			name: 'about'
		},
	]
});
//草地点击
	const toHandle = (item:any) => {
		if(item.children) return ;
		router.push(item.path);
		// 移动端
		if (checkDevice()){
			meun.show = false;
		}
	}
	const meunMousemove = (item:any) => {
		item.hover = true;
	}
	const meunMouseleave = (item:any) => {
		item.hover = false;
	}
	const showMask = (item) => {
		if (item.showMask) {
		}
	}
	//菜单导航切换 显示/隐藏
	const changeMeunShow = () => {
		meun.show = !meun.show;
	}
	onMounted(() => {
		//getHeaderTop().then((res) => {})
		if (!checkDevice()) meun.show = true;
	})
	window.addEventListener('resize', function() {
	    if (checkDevice()) {
				meun.show = false;
			} else {
				meun.show = true;
			}
	});
	// 获取解决方案
	const obtainSolutionsClick = ()=>{
		EventBus.$emit("modelSolutionOpen");
	}
</script>

<style scoped lang="scss">
	.header {
		height: 70px;
		background: #FFFFFF;
		box-shadow: 0px 5px 5px 0px rgba(0, 0, 8, 0.05);
		position: fixed;
		left: 0;
		top: 0;
		right: 0;
		display: flex;
		align-items: center;
		justify-content: space-between;
		color: #000;
		padding: 0 100px;
		z-index: 99;
		.logo-link {
			display: flex;
			align-items: center;
		}
		.logo {
			flex: 1;
			display: flex;
			align-items: center;
			height: 100%;
			img {
				width: auto;
				height: 35px;
			}
		}
		.router_menu-btn {
			display: none;
		}
		.router_menu {
			display: flex;
			align-items: center;
			.router_menu_item {
				padding: 0 40px;
				flex-shrink: 0;
				height: 70px;
				font-family: Source Han Sans CN;
				position: relative;
				a {
					display: block;
					font-size: 18px;
					color: #000000;
					line-height: 70px;
				}
				.sub-meun {
					display: none;
					position: fixed;
					left: 0;
					right: 0;
					background-color: #fff;
					box-shadow: 0 5px 5px rgba(0, 0, 8, 0.02);
				}
				&:hover {
					z-index: 9;
					.sub-meun {
						display: block;
					}
				}
				&:hover,
				&.is-active {
					.router-link-active {
						color: #0055D9;
						display: block;
						&::after {
							content: "";
							position: absolute;
							left: 40px;
							right: 40px;
							bottom: 0;
							border-bottom: 3px solid #0055D9;
						}
					}
				}
			}
		}
		.router_menu:hover~.header_mask {
			transform: translateY(0)
		}
		.case_btn {
			margin-left: 50px;
			padding:0 25px;
			height: 48px;
			border: 1px solid #0055D9;
			border-radius: 30px;
			color: #0055D9;
			font-size: 15px;
			font-family: Source Han Sans CN;
			cursor: pointer;
			outline: none;
		}
	}

	.header_mask {
		position: absolute;
		top: 100%;
		/* 初始位置在 .header 下方 */
		left: 0;
		width: 100%;
		background: #fefeff;
		transition: transform 0.5s ease-in-out;
		/* 添加动画效果 */
		// transform: translateY(-1000%); /* 初始状态隐藏 */
		z-index: 10;
		/* 确保 .header_mask 在最上层 */
		opacity: 1;
		box-shadow: #0155d9;
	}
	@media screen and (max-width: 1024px) {
	  .header {
			height: 108px;
			padding: 0 20px;
			.logo {
				img {
					height: 60px;
				}
			}
			.router_menu-btn {
				margin-left: 30px;
				display: block;
				cursor: pointer;
				:deep(svg) {
					display: block;
				}
			}
			.router_menu {
				position: fixed;
				border-top: 2px solid #e3e3e3;
				top: 108px;
				bottom: 0;
				left: 0;
				width: 100%;
				background-color: #f0f6ff;
				display: block;
				.router_menu_item {
					font-size: 30px;
					height: auto;
					line-height: inherit;
					padding: 0;
					position: static;
					&:hover {
						z-index: 9;
						.sub-meun {
							display: block;
							z-index: 9;
						}
					}
					&:hover,
					&.is-active {
						.router-link-active {
							color: #0055D9;
							background-color: #fff;
							&::after {
								display: none;
							}
							&+.sub-meun {
								display: block;
							}
						}
					}
					& > a {
						line-height: 100px;
						padding: 10px 30px;
						display: flex;
						color: #000;
						font-size: 30px;
					}
					.sub-meun {
						display: none;
						position: absolute;
						right: 0;
						left: inherit;
						top: 0;
						width: 68%;
						height: 100%;
						background-color: #fff;
					}
				}
			}
			.case_btn {
				height: 72px;
				font-size: 24px;
				margin: 0;
				line-height: 68px;
				border-radius: 40px;
				padding: 0 35px;
			}
	  }
	}
	@keyframes fadeInOut {
		0% {
			opacity: 0;
			// transform: translateX(-1000px);
			/* 完全透明 */
		}

		100% {
			opacity: 1;
			// transform: translateX(0);
			/* 再次完全透明 */
		}
	}
</style>